import { Box, Group, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { ControllerBatteryState, ControllerConnectionState } from "types/productTypes";
import { getControllerBatterySummary } from "@utils/controllerBatteryUtils";

interface ControllerBatteryTooltipContentProps {
  controllerState: ControllerConnectionState | null;
  controllerBattery: ControllerBatteryState | null;
  singleController?: boolean;
}

export default function ControllerBatteryTooltipContent({
  controllerState,
  controllerBattery,
  singleController = false,
}: ControllerBatteryTooltipContentProps) {
  const { t } = useTranslation();
  const controllerSummary = getControllerBatterySummary(
    controllerState,
    controllerBattery,
    singleController,
  );

  return (
    <Stack gap={6} style={{ minWidth: 240 }}>
      <Text fw={700} c="dark.8" size="sm">
        {t("ControllerStatus.summaryTitle")}
      </Text>
      {controllerSummary.map((summary) => (
        <Group
          key={summary.hand}
          gap={8}
          wrap="nowrap"
          align="center"
          justify="space-between"
          px={8}
          py={6}
          style={{
            borderRadius: 10,
            background: "rgba(148, 163, 184, 0.12)",
          }}
        >
          <Group gap={8} wrap="nowrap" align="center">
            {!singleController && (
              <Box
                px={7}
                py={2}
                style={{
                  borderRadius: 999,
                  background: "rgba(37, 99, 235, 0.12)",
                  minWidth: 22,
                  textAlign: "center",
                }}
              >
                <Text fw={700} c="blue.8" size="xs">
                  {summary.hand === "left"
                    ? t("ControllerStatus.leftHandLabel")
                    : t("ControllerStatus.rightHandLabel")}
                </Text>
              </Box>
            )}
            <Text c="dark.6" size="sm">
              {summary.connected
                ? t("ControllerStatus.connected")
                : t("ControllerStatus.disconnected")}
            </Text>
          </Group>

          <Group gap={8} wrap="nowrap" align="center">
            <Text c="dark.8" fw={600} size="sm">
              {summary.battery !== null
                ? `${summary.battery}%`
                : t("ControllerStatus.batteryUnavailable")}
            </Text>
            {summary.lowBattery ? (
              <Text c="red.7" fw={700} size="xs">
                {t("ControllerStatus.lowBattery")}
              </Text>
            ) : null}
          </Group>
        </Group>
      ))}
    </Stack>
  );
}
